<template>
  <div class="hero-body">
    <div class>
      <div class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <a href="#">{{bot.name}}</a>
          </li>
          <li class="is-active">
            <a href="#">{{title}}</a>
          </li>
        </ul>
      </div>
      <h2 class="title-header-2">{{title}}</h2>
      <div class="upload-file">
        <div class="file has-name is-right">
          <div class="field">
            <div class="control control-right">
              <span class="select is-info">
                <select v-model="limit">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                  <option>100</option>
                </select>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="bar">
        <nav class="navbar z-index-0" @changeChecked="changeChecked">
          <div class="navbar-menu toolbar" v-if="checkedNames.length == 0">
            <div class="navbar-start">
              <a class="navbar-item" @click="add()">
                <i class="fa fa-plus"></i>&nbsp;&nbsp;Create Entity
              </a>
            </div>
            <div class="navbar-start">
              <a class="navbar-item" @click="addPattern()">
                <i class="fa fa-plus"></i>&nbsp;&nbsp;Create Pattern Entity
              </a>
            </div>
            <div class="navbar-end">
              <div class="navbar-item">
                <div class="field">
                  <div class="control">
                    <input class="input" v-model="search" type="text" placeholder="Search Entity" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar-menu toolbar" v-else>
            <div class="navbar-start">
              <a class="navbar-item" @click="edit()" v-if="checkedNames.length < 2">
                <i class="fas fa-pencil-alt"></i>&nbsp;&nbsp;Rename
              </a>
              <a class="navbar-item" @click="deleteEntity()">
                <i class="fas fa-trash-alt"></i>&nbsp;&nbsp;Delete
              </a>
            </div>
            <div class="navbar-end">
              <div class="navbar-item">
                <div class="field">
                  <div class="control">
                    <input class="input" v-model="search" type="text" placeholder="Search Entity" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <new-entity-modal
            :id="'entity'"
            :text="'modal entity'"
            :choix="choix"
            :update="elemntChecked"
            :listEntity="entities"
            :nameEntity="nameEntity"
          ></new-entity-modal>

          <remove-entity-modal
            :id="'entityDelete'"
            :text="'modal entity'"
            :checked="checked"
            :remove="checkedNames"
            @changeChecked="changeChecked"
          ></remove-entity-modal>
          <update-pattern-modal
            :id="'updatePatternModal'"
            :text="'modal entity Pattern'"
            :update="entityy"
            :listEntity="entities"
            :nameEntity="nameEntity"
          ></update-pattern-modal>
          <pattern-modal
            :id="'patternmodal'"
            :text="'modal entity Pattern'"
            :choix="choixPattern"
            :update="elemntChecked"
            :listEntity="entities"
            :nameEntity="nameEntity"
          ></pattern-modal>
        </nav>
      </div>
      <div class="body-page">
        <div class="flex-1-auto">
          <table class="table is-hoverable is-fullwidth">
            <thead>
              <tr v-if="entitiees.length == 0">
                <h2 style="margin-left: 32%; margin-top: 10%; color: gray;">You have no entity</h2>
                <h2 style="margin-left: 30%; color: gray;">Create your first entity</h2>
                <!-- <button class="button first-letter" style="margin-left: 41%; margin-top: 25px;" @click="add()">
                    <i class="fa fa-plus" style="margin-right: 5px;"></i>Create Entity 
                </button>-->
                <td></td>
              </tr>
              <tr v-else>
                <th>
                  <div class="field">
                    <input
                      class="is-checkradio entities"
                      id="champ"
                      type="checkbox"
                      @click="allChecked"
                      name="champ"
                    />
                    <label for="champ"></label>
                  </div>
                </th>
                <th class="is-4">
                  <abbr title="Name">Name</abbr>
                </th>
                <th class="is-4">
                  <abbr title="Type">Type</abbr>
                </th>
                <!--  <th class=" is-4"><abbr title="Utterances">Labeled Utterances</abbr></th>-->
              </tr>
            </thead>
            <tbody>
              <tr v-if="typeof entitiees.length == 0">
                <h2 style="margin-left: 32%; margin-top: 10%; color: gray;">You have no entity</h2>
                <h2 style="margin-left: 30%; color: gray;">Create your first entity</h2>
                <button
                  class="button first-letter"
                  style="margin-left: 41%; margin-top: 25px;"
                  @click="add()"
                >
                  <i class="fa fa-plus" style="margin-right: 5px;"></i>Create Entity
                </button>
                <td></td>
              </tr>
              <tr v-else v-for="(entity, index) in paginat" :key="index">
                <th class="line">
                  <div class="field">
                    <input
                      class="is-checkradio entities"
                      :id="entity._id"
                      type="checkbox"
                      :value="entity"
                      v-model="checkedNames"
                      @click="selectOne"
                    />

                    <label :for="entity._id"></label>
                  </div>
                </th>
                 <td >
                  <a v-if="entity.type =='pattern'" @click="entityupdate(entity)" :style="{ color: entity.color}">
                    <strong style="font-size: larger">{{ entity. name}}</strong>
                  </a>
                  <a v-else @click="entityupdater(entity)" :style="{ color: entity.color}">
                    <strong style="font-size: larger">{{ entity. name}}</strong>
                  </a>
                </td>
                <td>
                  <a v-if="entity.type =='pattern'" @click="entityupdate(entity)" :style="{ color: entity.color}">
                    <strong style="font-size: larger">{{ entity. type}}</strong>
                  </a>
                  <a v-else @click="entityupdater(entity)" :style="{ color: entity.color}">
                  <strong style="font-size: larger">{{ entity. type}}</strong>
                  </a>
                  
                </td>
            
              </tr>
            </tbody>
            <tfoot></tfoot>
          </table>
        </div>
        <nav class="pagination is-centered" role="navigation" aria-label="pagination">
          <a class="pagination-previous" @click="prevPage()">Previous</a>
          <a
            class="pagination-next"
            :class="this.currentPage >= this.numPages ? 'disabled ': ''"
            @click="nextPage()"
          >Next page</a>

          <ul class="pagination-list" style="width: 80%;margin-left: auto;margin-right: auto;">
            <li v-for="(np, key) in numPages" :key="key">
              <a
                class="pagination-link"
                @click="currentPage = np"
                :class="np == currentPage ? 'is-current' : ''"
              >{{np}}</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import EntitiesMixin from "@/mixins/mixin.entities.js";
import botMixin from "@/mixins/mixin.bot.js";

const NewEntityModal = () =>
  import(
    "@/components/Entities/components/entities.add.modal.new.component.vue"
  );
const PatternModal = () =>
  import(
    "@/components/Entities/components/entities.add.pattern.modal.new.component.vue"
  );
const UpdatePatternModal = () =>
  import(
    "@/components/Entities/components/entities.pattern.update.component.vue"
  );
const RemoveEntityModal = () =>
  import(
    "@/components/Entities/components/entity.remove.modal.new.component.vue"
  );
export default {
  mixins: [EntitiesMixin, botMixin],

  data() {
    return {
      entityy:{},
      nameEntity: "",
      betweenChek: false,
      afterChek: false,
      afterFirstChek: false,
      afterLastChek: false,
      beforeChek: false,
      beforeFirstChek: false,
      beforeLastChek: false,
      checkedNames: [],
      checkedNamesPattern: [],
      checked: false,
      checkedPattern: false,
      elemntChecked: {},
      limit: 10,
      currentPage: 1,
      totalPage: 1,
      title: "Entities",
      choix: "",
      choixPattern: "",
      update: {},
      search: ""
    };
  },
  created() {
    this.$store.dispatch("setAllEnts", this.$route.params.id);
  },

  computed: {
    bot() {
      return this.$store.getters.getBot;
    },
    entitiees() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
     
      return this.entities
        .filter(el => {
          return el.name.toLowerCase().includes(this.search.toLowerCase());
        })
        .sort(compare);
    },
    entitieesPattern() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      return this.entities
        .filter(el => {
          if (el.type === "pattern") {
            return el.name.toLowerCase().includes(this.search.toLowerCase());
          }
        })
        .sort(compare);
    },
    numPages() {
      let numPages = this.entitiees.length / this.limit;
      let numRound = Math.round(numPages);
      if (numRound < numPages) {
        return numRound + 1;
      } else {
        return numRound;
      }
    },

    paginat() {
      let totalCurrent = this.currentPage * this.limit;
      let start = (this.currentPage - 1) * this.limit;
      let ar = [];
      this.entitiees.filter((el, x) => {
        if (x >= start && x <= totalCurrent - 1) {
          ar.push(el);
        }
      });
      return ar;
    }
  },
  methods: {
    allChecked() {
      let all = document.querySelectorAll(".is-checkradio .entities");
      let init = document.getElementById("champ");
      console.log("tester init", init);
      if (init.checked == true) {
        console.log("hey this entities", this.entitiees);
        this.checkedNames = this.entitiees;
        all.forEach(element => {
          if (element.checked == false) {
            element.checked = true;
          }
        });
      } else {
        this.checkedNames = [];
        console.log("test all not checked ", this.checkedNames);
        all.forEach(element => {
          if (element.checked == true) {
            element.checked = false;
          }
        });
      }
    },
    allCheckedPattern() {
      let all = document.querySelectorAll(".is-checkradio .entities");
      let init = document.getElementById("champPattern");
      console.log("tester init", init);
      if (init.checkedPattern == true) {
        console.log("hey this entities", this.entitieesPattern);
        this.checkedNamesPattern = this.entitieesPattern;
        all.forEach(element => {
          if (element.checkedPattern == false) {
            element.checkedPattern = true;
          }
        });
      } else {
        this.checkedNamesPattern = [];
        console.log("test all not checked ", this.checkedNamesPattern);
        all.forEach(element => {
          if (element.checkedPattern == true) {
            element.checkedPattern = false;
          }
        });
      }
    },
    selectOne(id) {
      let elmnt = document.getElementById(id);
      let init = document.getElementById("champ");
      console.log("tets elemnt ", this.checkedNames);
    },
    selectOnePattern(id) {
      let elmnt = document.getElementById(id);
      let init = document.getElementById("champPattern");
      console.log("tets elemnt ", this.checkedNamesPattern);
    },
    changeCheckedPattern: function(val) {
      this.checkedPattern = val;
      console.log("this.changeChecked", this.checkedPattern);
      if (!this.checkedPattern) {
        this.checkedNamesPattern = [];
      }
      setTimeout(() => {
        this.$forceUpdate();
      });
    },
    changeChecked: function(val) {
      this.checked = val;
      console.log("this.changeChecked", this.checked);
      if (!this.checked) {
        this.checkedNames = [];
      }
      setTimeout(() => {
        this.$forceUpdate();
      });
    },

    addPattern() {
      console.log("##################### add pattern");
      this.choixPattern = "add";
      this.$hyModal.show("patternmodal");
    },

    add() {
      this.choix = "add";
      this.$hyModal.show("entity");
      this.changeChecked(false);
    },
    entityupdater(entity){
        this.nameEntity = entity.name;
        this.$store.dispatch("setEntityById", entity._id);
        this.$router.replace({
          path: entity._id,
          append: true
        });
    },
    entityupdate(entity) {
     
          this.nameEntity = entity.name;
      
         console.log("############ entity.pattern.afterFirst)",entity.name);
         let ptr=  entity.pattern
        this.entityy.betweenFirst = ptr.betweenFirst;
        this.entityy.betweenLast = ptr.betweenLast;
        this.entityy.after = ptr.after;
        this.entityy.afterFirst = ptr.afterFirst;
        this.entityy.afterLast = ptr.afterLast
        this.entityy.before = ptr.before;
        this.entityy.beforeFirst = ptr.beforeFirst;
        this.entityy.beforeLast = ptr.beforeLast;
        this.entityy.name = entity.name;
        this.entityy.bot = entity.bot;
        this.entityy.children = entity.children;
        this.entityy.color = entity.color;
        this.entityy.custom = entity.custom;
        this.entityy.pattern = entity.pattern;
        this.entityy.slug = entity.name;
        this.entityy.type = entity.type;
        this.entityy._id = entity._id;
        console.log("############ checkboxes ",this.entityy.name);
        if (this.entityy.betweenFirst === "") {
          this.entityy.betweenChek = false;
        } else {
          this.entityy.betweenChek = true;
        }
        if (this.entityy.after === "") {
          this.entityy.afterChek = false;
        } else {
          this.entityy.afterChek = true;
        }
        if (this.entityy.afterFirst === "") {
          this.entityy.afterFirstChek = false;
        } else {
          this.entityy.afterFirstChek = true;
        }
        if (this.entityy.afterLast === "") {
          this.entityy.afterLastChek = false;
        } else {
          this.entityy.afterLastChek = true;
        }
        if (this.entityy.before === "") {
          this.entityy.beforeChek = false;
        } else {
          this.entityy.beforeChek = true;
        }
        if (this.entityy.beforeFirst === "") {
          this.entityy.beforeFirstChek = false;
        } else {
          this.entityy.beforeFirstChek = true;
        }
        if (this.entityy.beforeLast === "") {
          this.entityy.beforeLastChek = false;
        } else {
          this.entityy.beforeLastChek = true;
        }

        console.log(
          "############# this.entityy.pattern ",
          this.entityy
        );
        console.log("############# this.entityy ", this.entityy);
        this.nameEntity = this.entityy.name;
        this.$hyModal.show("updatePatternModal");
      
    },
    edit() {
      this.elemntChecked = this.checkedNames[0];
      this.nameEntity = this.elemntChecked.name;
      if (this.elemntChecked.type === "pattern") {
           let ptr=  this.elemntChecked.pattern
        
        this.elemntChecked.betweenFirst = ptr.betweenFirst;
        this.elemntChecked.betweenLast = ptr.betweenLast;
        this.elemntChecked.after = ptr.after;
        this.elemntChecked.afterFirst = ptr.afterFirst;
        this.elemntChecked.afterLast = ptr.afterLast
        this.elemntChecked.before = ptr.before;
        this.elemntChecked.beforeFirst =  ptr.beforeFirst;
        this.elemntChecked.beforeLast =ptr.beforeLast;
        this.elemntChecked.name = this.elemntChecked.name;
        this.elemntChecked.bot = this.elemntChecked.bot;
        this.elemntChecked.children = this.elemntChecked.children;
        this.elemntChecked.color = this.elemntChecked.color;
        this.elemntChecked.custom = this.elemntChecked.custom;
        this.elemntChecked.pattern = this.elemntChecked.pattern;
        this.elemntChecked.slug = this.elemntChecked.name;
        this.elemntChecked.type = this.elemntChecked.type;
        this.elemntChecked._id = this.elemntChecked._id;

        if (this.elemntChecked.betweenFirst === "") {
          this.elemntChecked.betweenChek = false;
        } else {
          this.elemntChecked.betweenChek = true;
        }
        if (this.elemntChecked.after === "") {
          this.elemntChecked.afterChek = false;
        } else {
          this.elemntChecked.afterChek = true;
        }
        if (this.elemntChecked.afterFirst === "") {
          this.elemntChecked.afterFirstChek = false;
        } else {
          this.elemntChecked.afterFirstChek = true;
        }
        if (this.elemntChecked.afterLast === "") {
          this.elemntChecked.afterLastChek = false;
        } else {
          this.elemntChecked.afterLastChek = true;
        }
        if (this.elemntChecked.before === "") {
          this.elemntChecked.beforeChek = false;
        } else {
          this.elemntChecked.beforeChek = true;
        }
        if (this.elemntChecked.beforeFirst === "") {
          this.elemntChecked.beforeFirstChek = false;
        } else {
          this.elemntChecked.beforeFirstChek = true;
        }
        if (this.elemntChecked.beforeLast === "") {
          this.elemntChecked.beforeLastChek = false;
        } else {
          this.elemntChecked.beforeLastChek = true;
        }


        this.nameEntity = this.elemntChecked.name;
        this.choixPattern = "edit";
        this.$hyModal.show("patternmodal");
        this.changeChecked(false);
        this.checkedNames = [];
      } else {
        this.choix = "edit";
        this.$hyModal.show("entity");
        this.changeChecked(false);
        this.checkedNames = [];
      }
    },
    deleteEntity() {
      this.$hyModal.show("entityDelete");
      // this.changeChecked(false);
    },
    dispBlock(index, entity) {
      let elmnt = document.getElementById(index);
      let parent = elmnt.parentNode;
      let checkbox = document.querySelectorAll(".is-checkradio .entities");
      checkbox.forEach(el => {
        if (el.id == elmnt.id) {
          el.checked ? el.checked : !el.checked;
        } else {
          el.checked = false;
        }
      });
      this.checked = elmnt.checked;
      if (elmnt.checked) {
        parent.style.display = "block";
        this.elemntChecked = entity;
      } else parent.style.display = "none";
    },

    nextPage() {
      if (this.currentPage < this.numPages) {
        return this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        return this.currentPage--;
      }
    }
  },
  watch: {
    checked: function(newval) {
      this.checked = newval;
    },
    limit(newval) {
      this.currentPage = 1;
    },
    entities(newval){
    }
  },
  components: {
    NewEntityModal,
    UpdatePatternModal,
    RemoveEntityModal,
    PatternModal
  }
};
</script>

<style scoped lang="sass">


.z-index-0
  z-index: auto
.select:not(.is-multiple):not(.is-loading)::after 
  border-color: #3273dc;
  right: 1.125em;
  z-index: 0;


.content li
  margin-top: 0em

.content ul
  margin-left: 0em

.breadcrumb:not(:last-child)
  margin-bottom:  0rem
.spinner
  display: table
  margin-left: auto
  justify-content: baseline
  margin-right: auto
  vertical-align: middle
  min-height: 300px
  margin-top: 150px;
  opacity: 0.5
</style>



// WEBPACK FOOTER //
// src/components/Entities/components/list.entities.components.vue